<template>
  <div>
    <el-card>
      <el-row>
        <el-col class="flex-items">
          <div class="flex-items">
            <div class="tui-rowTitle">学届：</div>
            <el-select v-model="levelListValue" placeholder="请选择学届" @visible-change="StudyYearSelectResult"
              @change="onSelectLevel">
              <el-option v-for="item in levelList" :key="item.Id" :label="item.Name" :value="item.Id">
              </el-option>
            </el-select>
          </div>
          <div class="flex-items">
            <div class="tui-rowTitle">年级：</div>
            <el-select :popper-append-to-body="true" v-model="gradeValue" placeholder="请选择" @visible-change="GetGradeList"
              @change="onSelectGrade">
              <el-option v-for="item in gradeList" :key="item.Id" :label="item.Name" :value="item.Id">
              </el-option>
            </el-select>
          </div>
          <div class="flex-items">
            <div class="tui-rowTitle">班级：</div>
            <el-select multiple v-model="classListValue" placeholder="请选择" @visible-change="GetClassSelect"
              @change="onClassSelect">
              <el-option v-for="item in classList" :key="item.Id" :label="item.Name" :value="item.Id">
              </el-option>
            </el-select>
          </div>
          <div class="flex-items">
            <div class="tui-rowTitle">特殊类型：</div>
            <el-select v-model="specialType" multiple placeholder="请选择特殊类型">
              <el-option v-for="item in specialTypeList" :key="item.Id" :label="item.Name" :value="item.Name">
              </el-option>
            </el-select>
          </div>
          <el-date-picker style="margin-left: 20px" v-model="date" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
          <el-input style="margin-left: 20px; width: 250px" v-model="studentName" placeholder="请输入姓名"></el-input>
          <el-input style="margin-left: 20px; width: 250px" v-model="ClassName" placeholder="请输入班级名称"></el-input>
          <el-button style="margin-left: 20px" type="goon" @click.native="onClickSearch">查询</el-button>
          <el-button style="margin-left: 20px" type="goon" @click.native="onReset">清空</el-button>
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin-top: 20px">
      <el-button type="goon" @click="onClickAdd">新增</el-button>
      <el-button type="goon" @click="onStudentExeal">模板下载</el-button>
      <el-button type="goon" @click="dialogVisibleImport = true">导入</el-button>
      <el-button type="goon" @click="onClickExcel">导出</el-button>
    </el-card>
    <el-card style="margin-top: 20px">
      <el-table :data="tableData" style="width: 100%" height="750" :header-cell-style="{
        background: '#F2F5FF',
        color: '#333',
        'text-align': 'center',
      }" :header-cell-class-name="headerCellClassName" border>
        <el-table-column label="序号" width="50" align="center" fixed="left">
          <template slot-scope="scope">
            {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="StudyYearName" label="学届" align="center" fixed="left" width="80">
        </el-table-column>
        <el-table-column prop="ClassName" label="班级" align="center" fixed="left">
        </el-table-column>
        <el-table-column prop="StudentName" label="姓名" align="center" fixed="left">
        </el-table-column>
        <el-table-column prop="SexName" label="性别" align="center" fixed="left" width="50">
        </el-table-column>
        <el-table-column prop="Birthday" label="出生年月" align="center" fixed="left">
        </el-table-column>
        <el-table-column prop="Ages" label="年龄" align="center" fixed="left">
        </el-table-column>
        <el-table-column prop="Weight" width="100" label="体重(KG)" align="center">
        </el-table-column>
        <el-table-column prop="WeightEvaluate" label="体重评价" align="center">
        </el-table-column>
        <el-table-column prop="Height" width="100" label="身高(CM)" align="center">
        </el-table-column>
        <el-table-column prop="HeightEvaluate" label="身高评价" align="center">
        </el-table-column>
        <el-table-column prop="HeightWeightEvaluate" label="身高测体重评价" align="center">
        </el-table-column>
        <el-table-column prop="BMI" label="BMI" align="center">
        </el-table-column>
        <el-table-column prop="GrowthDelayed" label="生长迟缓" align="center">
        </el-table-column>
        <el-table-column prop="LowWeight" label="低体重" align="center">
        </el-table-column>
        <el-table-column prop="HighWeight" label="肥胖评价" align="center">
        </el-table-column>
        <el-table-column prop="Thin" label="消瘦评价" align="center">
        </el-table-column>
        <el-table-column prop="VisionLeft" label="视力(左)" align="center">
        </el-table-column>
        <el-table-column prop="VisionRight" label="视力(右)" align="center">
        </el-table-column>
        <el-table-column prop="VisionEvaluate" label="视力评价" align="center">
        </el-table-column>
        <el-table-column label="听力(左)" align="center">
          <template slot-scope="scope">
            {{ scope.row.HearingLeft ? "正常" : "不正常" }}
          </template>
        </el-table-column>
        <el-table-column label="听力(右)" align="center">
          <template slot-scope="scope">
            {{ scope.row.HearingRight ? "正常" : "不正常" }}
          </template>
        </el-table-column>
        <el-table-column prop="Hemoglobin" label="血色素(g/l)" align="center">
        </el-table-column>
        <el-table-column prop="HemoglobinEvaluate" label="血色素评价" align="center">
        </el-table-column>

        <el-table-column prop="Tooth" label="龋齿" width="50" align="center">
        </el-table-column>

        <el-table-column prop="TestDate" label="体检日期" align="center">
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="100" align="center">
          <template slot-scope="scope">
            <div>
              <el-button type="text" style="color: #4083fe" @click="onClickEdit(scope.row)">编辑</el-button>
              <el-button type="text" @click="onClickDelete(scope.row)" style="color: #e14747">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]" :page-size="PageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total" style="text-align: center;padding:20px; 0 0 0">
      </el-pagination>
    </el-card>
    <el-dialog :title="Title" :visible.sync="dialogVisible" width="30%">
      <div>
        <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm" label-position="top" :rules="rules">
          <el-form-item label="学届" prop="studyYearId" v-if="Title == '新增'">
            <el-select :disabled="Title == '编辑' ? true : false" v-model="ruleForm.studyYearId" placeholder="请选择学届"
              @visible-change="AddStudyYearSelectResult" @change="addOnSelectLevel">
              <el-option v-for="item in addlevelList" :key="item.Id" :label="item.Name" :value="item.Id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年级" prop="addGradeValue" v-if="Title == '新增'">
            <el-select :disabled="Title == '编辑' ? true : false" v-model="ruleForm.addGradeValue" placeholder="请选择年级"
              @change="addOnSelectGrade">
              <el-option v-for="item in addGradeList" :key="item.Id" :label="item.Name" :value="item.Id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="班级" prop="classId" v-if="Title == '新增'">
            <el-select :disabled="Title == '编辑' ? true : false" v-model="ruleForm.classId" placeholder="请选择班级"
              @visible-change="AddGetClassSelect" @change="GetStudentByPage">
              <el-option v-for="item in addClassList" :key="item.Id" :label="item.Name" :value="item.Id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="姓名" prop="studentName">
            <el-select :disabled="Title == '编辑' ? true : false" v-model="ruleForm.studentName" placeholder="请选择学生">
              <el-option v-for="item in studentList" :key="item.Id" :label="item.StudentName" :value="item.StudentName">
              </el-option>
            </el-select>
            <!-- <el-input
              :disabled="Title == '编辑' ? true : false"
              v-model="ruleForm.studentName"
              placeholder="请输入姓名"
            ></el-input> -->
          </el-form-item>
          <el-form-item label="体重" prop="weight">
            <el-input type="number" v-model="ruleForm.weight" placeholder="请输入体重（KG）"></el-input>
          </el-form-item>
          <el-form-item label="身高" prop="height">
            <el-input type="number" v-model="ruleForm.height" placeholder="请输入身高（CM）"></el-input>
          </el-form-item>
          <el-form-item label="龋齿" prop="Tooth">
            <el-input type="number" v-model="ruleForm.Tooth" placeholder="请输入龋齿（个）"></el-input>
          </el-form-item>
          <el-form-item label="血色素" prop="hemoglobin">
            <el-input type="number" v-model="ruleForm.hemoglobin" placeholder="请输入血色素(g/l)"></el-input>
          </el-form-item>
          <el-form-item label="听力左" prop="hearingLeft">
            <el-radio-group v-model="ruleForm.hearingLeft">
              <el-radio :label="1">正常</el-radio>
              <el-radio :label="0">不正常</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="听力右" prop="hearingRight">
            <el-radio-group v-model="ruleForm.hearingRight">
              <el-radio :label="1">正常</el-radio>
              <el-radio :label="0">不正常</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="视力左" prop="visionLeft">
            <el-input type="number" v-model="ruleForm.visionLeft" placeholder="请输入左眼视力"></el-input>
          </el-form-item>
          <el-form-item label="视力右" prop="visionRight">
            <el-input type="number" v-model="ruleForm.visionRight" placeholder="请输入右眼视力"></el-input>
          </el-form-item>
          <el-form-item label="体检时间" prop="testDate">
            <el-date-picker v-model="ruleForm.testDate" type="date" value-format="yyyy-MM-dd" placeholder="选择体检日期">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="goon" @click="
          Title == '新增' ? addSubmit('ruleForm') : editSubmit('ruleForm')
          ">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="导入" :visible.sync="dialogVisibleImport">
      <el-upload class="image-uploader" :multiple="false" :auto-upload="true" list-type="excel" :show-file-list="true"
        :drag="true" action :limit="1" :on-exceed="handleExceed" :before-upload="beforeUpload" :http-request="uploadFile">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          一次只能上传一个文件，仅限excel格式，单文件不超过5MB
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleImport = false">取消</el-button>
        <el-button type="primary" @click="ImportStudent">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getAcademicSelect,
  GetClassSelect,
  GetPhysicalExaminationList,
  AddPhysicalExamination,
  DelPhysicalExamination,
  setUpdateClassInfo,
  FileUploadsExcel,
  ImportPhysicalExamination,
  GetGradeList,
  GetStudentByPage,
  ExportGetPhysicalExaminationList,
} from "../../api/api";

export default {
  data() {
    return {
      tableData: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      Title: "",
      dialogVisible: false,
      ruleForm: {
        classId: null,
        studyYearId: null,
        studentName: "",
        visionLeft: "",
        visionRight: "",
        weight: "",
        height: "",
        testDate: "",
        addGradeValue: null,
        Tooth: "",
        hemoglobin: "",
        hearingLeft: "",
        hearingRight: "",
      },
      gradeValue: null,
      gradeList: [],
      studentList: [],
      addGradeList: [],
      userInfo: {},
      addlevelList: [],
      levelList: [],
      levelListValue: null,
      classList: [],
      classListValue: null,
      addClassList: [],
      date: "",
      rules: {
        studentName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        studyYearId: [
          { required: true, message: "请选择学届", trigger: "change" },
        ],
        addGradeValue: [
          { required: true, message: "请选择年级", trigger: "change" },
        ],
        classId: [{ required: true, message: "请选择班级", trigger: "change" }],
        visionLeft: [
          { required: true, message: "请输入左眼视力", trigger: "blur" },
        ],
        visionRight: [
          { required: true, message: "请输入右眼视力", trigger: "blur" },
        ],
        hearingLeft: [
          { required: true, message: "请输入听力左", trigger: "change" },
        ],
        hearingRight: [
          { required: true, message: "请输入听力右", trigger: "change" },
        ],
        hemoglobin: [
          { required: true, message: "请输入血色素", trigger: "blur" },
        ],
        weight: [{ required: true, message: "请输入体重", trigger: "blur" }],
        height: [{ required: true, message: "请输入身高", trigger: "blur" }],
        Tooth: [{ required: true, message: "请输入龋齿", trigger: "blur" }],
        testDate: [
          { required: true, message: "请输入体检时间", trigger: "blur" },
        ],
      },
      dialogVisibleImport: false,
      excelurl: "",
      gradeId: 0,
      addGradeId: 0,
      studentName: "",
      specialTypeList: [
        {
          Id: 0,
          Name: "低体重",
        },
        {
          Id: 1,
          Name: "生长迟缓",
        },
        {
          Id: 2,
          Name: "消瘦",
        },
        {
          Id: 3,
          Name: "超重",
        },
        {
          Id: 4,
          Name: "轻度肥胖",
        },
        {
          Id: 5,
          Name: "中重肥胖",
        },
        {
          Id: 6,
          Name: "中度贫血",
        },
        {
          Id: 7,
          Name: "重度贫血",
        },
        {
          Id: 8,
          Name: "极重度贫血",
        },
      ],
      specialType: [],
      ClassName: "",
    };
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.user);
    this.GetPhysicalExaminationList();
  },
  methods: {
    headerCellClassName({ column, columnIndex }) {
      //console.log(columnIndex, "columnIndex");
      // 在这里定义表头样式逻辑
      if (columnIndex < 7 || columnIndex == 26) {
        // 对前七个表头应用自定义类名
        return "custom-header-background";
      }
      // 其他表头不修改样式
      return "";
    },
    onClickSearch() {
      this.PageIndex = 1;
      this.PageSize = 10;
      this.GetPhysicalExaminationList();
    },
    async onClickExcel() {
      const params = {
        ClassId: Number(this.classListValue),
        gradeId: this.gradeId,
        SchoolId: this.userInfo.SchoolId,
        StudyYearId: Number(this.levelListValue),
        startTime: this.date == null ? "" : this.date[0],
        endTime: this.date == null ? "" : this.date[1],
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: this.studentName,
        SpecialType: this.specialType.join("、"),
        ClassName: this.ClassName,
      };
      let res = await ExportGetPhysicalExaminationList(params);
      // console.log(res);
      if (res.data.success) {
        window.open(res.data.response, "_blank");
      } else {
        this.$message({
          type: "error",
          message: "导出失败！",
        });
      }
    },
    // 重置
    onReset() {
      this.ruleForm = {
        classId: null,
        studyYearId: null,
        studentName: "",
        visionLeft: "",
        visionRight: "",
        weight: "",
        height: "",
        testDate: "",
        Tooth: "",
        addGradeValue: null,
      };
      this.gradeValue = null;
      this.levelListValue = null;
      this.classListValue = null;
      this.studentName = "";
      this.ClassName = "";
      this.date = "";
    },
    // 年级下拉
    async GetGradeList() {
      let res = await GetGradeList({
        SchoolId: this.userInfo.SchoolId,
        studyYearId: this.levelListValue ? this.levelListValue : 0,
        Uid: this.userInfo.uID,
      });

      if (res.data.success) {
        this.gradeList = res.data.response;
      }
    },
    async onSelectGrade(val) {
      this.PageIndex = 1;
      this.gradeId = val;
      await this.GetClassSelect();
    },
    async addOnSelectGrade(val) {
      this.ruleForm.addGradeValue = val;
      this.PageIndex = 1;
      this.addGradeId = val;
      await this.AddGetClassSelect();
    },
    onStudentExeal() {
      location.href =
        "http://www.mushroomisland.cn/exceldown/%E8%98%91%E8%8F%87%E5%B2%9BV3%E5%B9%BC%E5%84%BF%E8%BA%AB%E9%AB%98%E4%BD%93%E9%87%8D%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";
    },
    //上传文件
    ImportStudent() {
      if (this.excelurl) {
        ImportPhysicalExamination({
          fileName: this.excelurl,
          Uid: this.userInfo.uID,
          SchoolId: this.userInfo.SchoolId,
          UserName: this.userInfo.uRealName,
        }).then((res) => {
          if (res.data.success) {
            this.$message({
              message: "成功",
              type: "success",
            });
            //初始化数据
            this.dialogVisibleImport = false;
            this.GetPhysicalExaminationList();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      } else {
        this.$message({
          message: "请选择文件",
          type: "error",
        });
      }
    },
    //导入
    uploadFile(item) {
      //    //console.log(this.comId);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      //    form.append("comId", this.comId);
      form.append("filetype", "excel");
      // //console.log(form);
      //debugger;
      FileUploadsExcel(form).then((res) => {
        //console.log(res, "aaaaaaaaa");
        this.excelurl = res.data.response;
        // //console.log(response);
        // //console.log(this.excelurl);
        this.$message.info("文件：" + fileObj.name + "上传成功");
      });
    },
    // 上传文件个数超过定义的数量
    handleExceed() {
      this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传`);
    },
    beforeUpload(file) {
      //console.log("beforeUpload");
      // //console.log(file.type);
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      return isText | isTextComputer;
    },
    //   编辑
    async onClickEdit(row) {
      this.Title = "编辑";
      //console.log(row);
      this.ruleForm = {
        Id: row.Id,
        classId: row.ClassId,
        studyYearId: row.StudyYearId,
        studentName: row.StudentName,
        visionLeft: row.VisionLeft,
        visionRight: row.VisionRight,
        weight: row.Weight,
        height: row.Height,
        testDate: row.TestDate,
        SchoolId: row.SchoolId,
        Tooth: row.Tooth,
        hemoglobin: row.Hemoglobin,
        hearingLeft: row.HearingLeft ? 1 : 0,
        hearingRight: row.HearingRight ? 1 : 0,
      };
      this.dialogVisible = true;
    },
    //   删除
    async onClickDelete(row) {
      this.$confirm("此操作将永久删除该体检记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await DelPhysicalExamination({ ids: [row.Id] });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.GetPhysicalExaminationList();
        } else {
          this.$message({
            type: "error",
            message: "删除失败!",
          });
        }
      });
    },
    async editSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await setUpdateClassInfo(this.ruleForm);
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "修改成功",
            });
            this.dialogVisible = false;
            this.$refs[formName].resetFields();
            this.GetPhysicalExaminationList();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    //   新增
    async addSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.ruleForm.SchoolId = this.userInfo.SchoolId;
          this.ruleForm.hearingLeft =
            this.ruleForm.hearingLeft == 1 ? true : false;
          this.ruleForm.hearingRight =
            this.ruleForm.hearingRight == 1 ? true : false;

          let res = await AddPhysicalExamination(this.ruleForm);
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "新增成功",
            });
            this.dialogVisible = false;
            this.$refs[formName].resetFields();
            this.GetPhysicalExaminationList();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    //   获取健康体检列表
    async GetPhysicalExaminationList() {
      const params = {
        ClassIds: this.classId,
        gradeId: this.gradeId,
        SchoolId: this.userInfo.SchoolId,
        StudyYearId: Number(this.levelListValue),
        startTime: this.date == null ? "" : this.date[0],
        endTime: this.date == null ? "" : this.date[1],
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: this.studentName,
        SpecialType: this.specialType.join("、"),
        ClassName: this.ClassName,
      };
      console.log(params,"params")
      let res = await GetPhysicalExaminationList(params);
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    //   学届下拉
    async StudyYearSelectResult() {
      let res = await getAcademicSelect({
        SchoolId: this.userInfo.SchoolId,
        Uid: this.userInfo.uID,
      });
      if (res.data.success) {
        this.levelList = res.data.response;
      }
    },
    //   学届下拉
    async AddStudyYearSelectResult() {
      let res = await getAcademicSelect({
        SchoolId: this.userInfo.SchoolId,
        Uid: this.userInfo.uID,
      });
      if (res.data.success) {
        this.addlevelList = res.data.response;
      }
    },
    onSelectLevel(e) {
      this.levelListValue = e;
      this.gradeList = [];
      this.gradeValue = null;
      this.classList = [];
      this.classListValue = null;
      this.GetGradeList();
    },
    async addOnSelectLevel(e) {
      this.addclassList = [];
      this.ruleForm.studyYearId = e;
      this.ruleForm.classId = null;
      this.ruleForm.addGradeValue = null;
      let res = await GetGradeList({
        SchoolId: this.userInfo.SchoolId,
        studyYearId: this.ruleForm.addGradeValue,
        Uid: this.userInfo.uID,
      });

      if (res.data.success) {
        this.addGradeList = res.data.response;
      }
    },
    async GetClassSelect() {
      let res = await GetClassSelect({
        SchoolId: this.userInfo.SchoolId,
        Uid: this.userInfo.uID,
        StudyYearId: Number(this.levelListValue),
        gradeId: this.gradeId,
      });
      if (res.data.success) {
        this.classList = res.data.response;
      }
    },
    onClassSelect(val) {
      console.log(val,"aa")
      this.PageIndex = 1;
      this.classId = val;

      // this.GetReadArticleList();
    },
    async AddGetClassSelect() {
      let res = await GetClassSelect({
        Uid: this.userInfo.uID,
        SchoolId: this.userInfo.SchoolId,
        StudyYearId: Number(this.ruleForm.studyYearId),
        gradeId: this.addGradeId,
      });
      if (res.data.success) {
        this.addClassList = res.data.response;
      }
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetPhysicalExaminationList();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetPhysicalExaminationList();
    },
    async GetStudentByPage() {
      let params = {
        SchoolId: this.userInfo.SchoolId,
        StudyYearId: Number(this.ruleForm.studyYearId),
        gradeId: this.addGradeId,
        ClassId: this.ruleForm.ClassId,
        Uid: this.userInfo.uID,
      };
      let res = await GetStudentByPage(params);
      if (res.data.success) {
        this.studentList = res.data.response.data;
      } else {
        this.studentList = [];
      }
    },
    async onClickAdd() {
      this.Title = "新增";
      this.onReset();
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="less" >
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}

.custom-header-background {
  background-color: #dcdfe6 !important;
  /* 设置自定义背景颜色 */
  /* 可以添加其他自定义样式，根据需要 */
}

.tui-rowTitle {
  margin-left: 10px;
}
</style>